// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__yGlsh","options":"Select_options__hT0IX","list":"Select_list__YeKoE","option":"Select_option__FzCij"};